import { HttpApiService } from "@/shared/services/httpApi.service";

import type { RateProviderUsageReport } from "../types/rateProviderUsage.types";

/**
 * Rate-provider quota counters — coloca-nest `InternalRatesController.getProviderUsage` (`GET
 * /internal/payments/rates/provider-usage`, `payments:read` + `userTypes: [INTERNAL]`).
 *
 * Counts rows in the append-only `rate_provider_requests` log, which records one row per OUTBOUND provider
 * call whatever its outcome. It is deliberately not read from the rate archive: failover is per request, so a
 * primary that fails on every refresh spends its quota while the row persisted to `exchange_rate_history`
 * carries the FALLBACK's provider, leaving the primary at zero rows there.
 *
 * `from` / `to` are inclusive ISO instants; omitting both asks for the running calendar month in UTC, which
 * is how the providers bill.
 */

const USAGE_URL = "/internal/payments/rates/provider-usage";

export const RateProviderUsageService = {
  async get(from?: Date, to?: Date): Promise<RateProviderUsageReport> {
    const params = new URLSearchParams();
    if (from) params.set("from", from.toISOString());
    if (to) params.set("to", to.toISOString());
    const query = params.toString();
    const { data } = await HttpApiService.get<RateProviderUsageReport>(
      `${USAGE_URL}${query ? `?${query}` : ""}`,
    );
    return data;
  },
};
